<template>
  <button class="expand-button d-flex align-center justify-center"
          data-locator="expand-button">
    <app-icon-ds :icon="chevronIcon" size="xxxxs" weight="fas"/>
  </button>
</template>

<script>
const DIRECTIONS = Object.freeze({
  RIGHT: 'right',
  LEFT: 'left',
})

export default {
  name: 'ExpandButton',
  props: {
    direction: {
      type: String,
      validator (value) {
        // There's currently a bug in vue-styleguidist which makes us unable to check an array here...
        // So we should use this code instead if it becomes part of the styleguide:
        // return (value === DIRECTIONS.LEFT || value === DIRECTIONS.RIGHT)
        return [DIRECTIONS.LEFT, DIRECTIONS.RIGHT].includes(value)
      },
    },
  },
  computed: {
    chevronIcon () {
      if (this.direction === DIRECTIONS.LEFT) {
        return 'chevron-double-left'
      }

      return 'chevron-double-right'
    },
  },
}
</script>

<style lang="scss" scoped>
.expand-button {
  width: 20px;
  height: 20px;
  color: rgb(var(--v-theme-grey-600));
  border-radius: 4px;
  border: 1px solid rgb(var(--v-theme-grey-100));
  background: white;
  box-shadow: 0px 1px 4px 0px #444A5014;
}
</style>
